export default __webpack_public_path__ + "static/media/news (2).1163de40.jpg";